module.exports = __webpack_public_path__ + "static/media/Team-Cover.84b296f2.jpg";